import React  from "react";
import { FormatMessage } from "react-globalize";
import { getBulletAndText, getListItems } from "../globalizationUtils";

export default function SectionUserAgreement(props)
{
  let locale = props.locale || 'en';  

  return (
    <div id="agreement">
    <div className="title">
      <h3><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/title" /></h3>
    </div>
    <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/preamble1" elements={{link: <a className="strong" href="https://www.barri.com"></a>}}/></p>
    <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/preamble2"/></p>
    <ol>
      <li id="agreementSERVICE">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementSERVICE", "quisqueyanaPolicy/agreement/SERVICE/title")}</h4>
        <div className="agreementSERVICE collapse collapsebleDiv">
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/SERVICE/line1"/></p>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/SERVICE/line2"/></p>
        </div>
      </li>
      <li id="agreementELIGIBILITY">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementELIGIBILITY", "quisqueyanaPolicy/agreement/ELIGIBILITY/title")}</h4>
        <div className="agreementELIGIBILITY collapse collapsebleDiv">
          <ol>
            {getListItems(locale, 6, "quisqueyanaPolicy/agreement/ELIGIBILITY/list", {bold: <strong></strong>})}
          </ol>
        </div>
      </li>
      <li id="agreementPAYING_SERVICE">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementPAYING_SERVICE", "quisqueyanaPolicy/agreement/PAYING_SERVICE/title")}</h4>
        <div className="agreementPAYING_SERVICE collapse collapsebleDiv">
          <ol>
            {getListItems(locale, 3, "quisqueyanaPolicy/agreement/PAYING_SERVICE/list", {bold: <strong></strong>})}
          </ol>
        </div>
      </li>
      <li id="agreementREMITTANCE">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementREMITTANCE", "quisqueyanaPolicy/agreement/REMITTANCE/title")}</h4>
        <div className="agreementREMITTANCE collapse collapsebleDiv">
          <ol>
            {getListItems(locale, 2, "quisqueyanaPolicy/agreement/REMITTANCE/list", {bold: <strong></strong>})}
          </ol>
        </div>
      </li>

      <li id="agreementRESTRICTIONS">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementRESTRICTIONS", "quisqueyanaPolicy/agreement/RESTRICTIONS/title")}</h4>
        <div className="agreementRESTRICTIONS collapse collapsebleDiv">
          <ol>
            {getListItems(locale, 7, "quisqueyanaPolicy/agreement/RESTRICTIONS/list", {bold: <strong></strong>})}
          </ol>
        </div>
      </li>
      <li id="agreementCOLLECT">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementCOLLECT", "quisqueyanaPolicy/agreement/COLLECT/title")}</h4>
        <div className="agreementCOLLECT collapse collapsebleDiv">
          <ol>
            {getListItems(locale, 4, "quisqueyanaPolicy/agreement/COLLECT/list", {bold: <strong></strong>, link: <a className="strong" href="#privacy"></a>})}
          </ol>
        </div>
      </li>
      <li id="agreementPROBLEMS">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementPROBLEMS", "quisqueyanaPolicy/agreement/PROBLEMS/title")}</h4>
        <div className="agreementPROBLEMS collapse collapsebleDiv">
          <ol>
            <li>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/0/title" elements={{bold: <strong></strong>}}/>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/0/value" elements={{resolutionLink: <a className="strong" href="https://www.barri.com/bfgResolution"></a>}}/>

            </li>
            <li>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/title" elements={{bold: <strong></strong>}}/>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/value/paragraph1" elements={{bold: <strong></strong>}}/><br/>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/value/paragraph2" elements={{bold: <strong></strong>}}/><br/>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/value/paragraph3/intro" elements={{bold: <strong></strong>}}/><br/>
              <ul>
                <li>
                  <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/value/paragraph3/unorderedList/0/intro" elements={{bold: <strong></strong>}}/>
                  <ul>
                    <li>
                      <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/value/paragraph3/unorderedList/0/list/0" elements={{bold: <strong></strong>}}/>
                    </li>
                    <li>
                      <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/value/paragraph3/unorderedList/0/list/1" elements={{bold: <strong></strong>}}/>
                    </li>
                    <li>
                      <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/value/paragraph3/unorderedList/0/list/2" elements={{bold: <strong></strong>}}/>
                    </li>
                    <li>
                      <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/value/paragraph3/unorderedList/0/list/3" elements={{bold: <strong></strong>}}/>
                    </li>
                  </ul>
                </li>
                <li>
                  <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/value/paragraph3/unorderedList/1/intro" elements={{bold: <strong></strong>}}/>
                  <ul>
                    <li>
                      <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/1/value/paragraph3/unorderedList/1/list/0" elements={{bold: <strong></strong>, link: <a className="strong" href="https://www.dob.texas.gov/"></a>, phone1: <a className="strong" href="tel:+18662713202"></a>, phone2: <a className="strong" href="tel:+18772765554"></a>}}/>
                    </li>
                  </ul>
                </li>
              </ul> 
            </li>
            <li>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/2/title" elements={{bold: <strong></strong>}}/>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/PROBLEMS/list/2/value" elements={{consumerFinanceLink: <a className="strong" href="https://www.consumerfinance.gov/"></a>}}/>
            </li>
          </ol>
        </div>
      </li>
      <li id="agreementINTELLECTUAL">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementINTELLECTUAL", "quisqueyanaPolicy/agreement/INTELLECTUAL/title")}</h4>
        <div className="agreementINTELLECTUAL collapse collapsebleDiv">
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/INTELLECTUAL/line1"/></p>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/INTELLECTUAL/line2"/></p>
        </div>
      </li>
      <li id="agreementWARRANTIES">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementWARRANTIES", "quisqueyanaPolicy/agreement/WARRANTIES/title")}</h4>
        <div className="agreementWARRANTIES collapse collapsebleDiv">
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/WARRANTIES/info"/></p>
        </div>
      </li>
      <li id="agreementINDEMNITY">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementINDEMNITY", "quisqueyanaPolicy/agreement/INDEMNITY/title")}</h4>
        <div className="agreementINDEMNITY collapse collapsebleDiv">
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/INDEMNITY/info"/></p>
        </div>
      </li>
      <li id="agreementLIABILITY">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementLIABILITY", "quisqueyanaPolicy/agreement/LIABILITY/title")}</h4>
        <div className="agreementLIABILITY collapse collapsebleDiv">
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/LIABILITY/info"/></p>
        </div>
      </li>
      <li id="agreementLAW">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementLAW", "quisqueyanaPolicy/agreement/LAW/title")}</h4>
        <div className="agreementLAW collapse collapsebleDiv">
          <ol>
            {getListItems(locale, 6, "quisqueyanaPolicy/agreement/LAW/includedList", {bold: <strong></strong>, phone1: <a className="strong" href="tel:+18662713202"></a>, phone2: <a className="strong" href="tel:+17132195700"></a> })}
          </ol>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/LAW/note"/></p>
        </div>
      </li>
      <li id="agreementCOMMUNICATIONS">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementCOMMUNICATIONS", "quisqueyanaPolicy/agreement/COMMUNICATIONS/title")}</h4>
        <div className="agreementCOMMUNICATIONS collapse collapsebleDiv">
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/COMMUNICATIONS/line1"/></p>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/COMMUNICATIONS/line2"/></p>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/COMMUNICATIONS/line3"/></p>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/COMMUNICATIONS/line4"/></p>
        </div>
      </li>
      <li id="agreementMISCELLANEOUS">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementMISCELLANEOUS", "quisqueyanaPolicy/agreement/MISCELLANEOUS/title")}</h4>
        <div className="agreementMISCELLANEOUS collapse collapsebleDiv">
          <ol>
            {getListItems(locale, 5, "quisqueyanaPolicy/agreement/MISCELLANEOUS/list", {bold: <strong></strong>})}
          </ol>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/MISCELLANEOUS/note"/></p>
        </div>
      </li>
      <li id="agreementSECURITY">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementSECURITY", "quisqueyanaPolicy/agreement/SECURITY/title")}</h4>
        <div className="agreementSECURITY collapse collapsebleDiv">
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/SECURITY/line1" elements={{phone1: <a className="strong" href="tel:+18662713202"></a>, phone2: <a className="strong" href="tel:+17132195700"></a>}} /></p>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/SECURITY/line2" elements={{email1: <a className="strong" href="mailto:complaints@barri.com"></a>, email2: <a className="strong" href="mailto:complaints@barri.com"></a> }}/></p>
        </div>
      </li>
      <li id="agreementLANGUAGE">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementLANGUAGE", "quisqueyanaPolicy/agreement/LANGUAGE/title")}</h4>
        <div className="agreementLANGUAGE collapse collapsebleDiv">
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/LANGUAGE/line"/></p>
        </div>
      </li>
      <li id="agreementCONTACT">
        <h4 className="subTitle">{getBulletAndText(locale, "agreementCONTACT", "quisqueyanaPolicy/agreement/CONTACT/title")}</h4>
        <div className="agreementCONTACT collapse collapsebleDiv">
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/agreement/CONTACT/line" elements={{link: <a className="strong" href="https://www.barri.com/bfgResolution/"></a>, phone1: <a className="strong" href="tel:+18662713202"></a>, phone2: <a className="strong" href="tel:+17132195700"></a>}} /></p>
        </div>
      </li>
    </ol>
  </div>
  )
}


// WEBPACK FOOTER //
// ./js/SectionQuisqueyanaPolicy/SectionUserAgreement/SectionUserAgreement.js